var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgService = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "service_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#service_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M3 32v-3.2h33V32H3Zm1.65-4.8v-1.6c0-3.413 1.08-6.427 3.239-9.04 2.158-2.613 4.929-4.267 8.311-4.96V8h6.6v3.6c3.41.693 6.188 2.347 8.332 4.96 2.146 2.613 3.218 5.627 3.218 9.04v1.6H4.65ZM8.033 24h22.935c-.386-2.773-1.664-5.067-3.837-6.88-2.172-1.813-4.716-2.72-7.631-2.72s-5.452.907-7.61 2.72C9.73 18.933 8.445 21.227 8.033 24Z"
}))));
export default SvgService;